module.exports = __webpack_public_path__ + "img/logo.54b3b68b.svg";